import moment, { invalid } from "moment"
import { formatMoney, formatName } from "../../services/functions"

export const DRE_DEFAULT_BLOCK = {
  header: { id: 'header', type: 'neutral' }
}

export const DRE_MAX_SHOW_MONTHS = 5

export const DRE_GOALS = {
  margin: {
    id: 'Margem',
    label: 'Margem',
    number: true,
    suffix: '%',
    decimals: 1,
    disabled: true,
  },
  subscribers: {
    id: 'Assinaturas',
    label: 'Total de Assinantes',
    number: true,
    decimals: 0,
  },
  invoicing: {
    id: 'Faturamento',
    label: 'Faturamento',
    number: true,
    prefix: 'R$ ',
    decimals: 2,
  },
  cancellations: {
    id: 'Cancelamentos',
    label: 'Limite de Cancelamentos',
    number: true,
    decimals: 0,
  },
}

export const DRE_EXPENSES = {
  fee: {
    id: 'Taxa Transacional',
    group: 'Taxas',
    label: 'Taxa Transacional',
    suffix: '%',
    number: true,
    decimals: 1,
    disabled: true,
  },
  iss: {
    id: 'ISS',
    group: 'Taxas',
    label: 'ISS',
    suffix: '%',
    number: true,
    decimals: 1,
  },
  employees: {
    id: 'Pessoas',
    group: 'Pessoas',
    label: 'Salário base de um banhista',
    prefix: 'R$ ',
    number: true,
    decimals: 2,
  },
  commission: {
    id: 'Comissão',
    group: 'Pessoas',
    label: 'Comissão por banho',
    suffix: '%',
    number: true,
    decimals: 0,
  },
  neutralizing: {
    id: 'Shampoo Neutralizador',
    group: 'Banho/Produtos',
    label: 'Shampoo Neutralizador (5L)',
    prefix: 'R$ ',
    number: true,
    decimals: 2,
  },
  neutral: {
    id: 'Shampoo Neutro',
    group: 'Banho/Produtos',
    label: 'Shampoo Neutro (5L)',
    prefix: 'R$ ',
    number: true,
    decimals: 2,
  },
  conditioner: {
    id: 'Condicionador',
    group: 'Banho/Produtos',
    label: 'Condicionador (5L)',
    prefix: 'R$ ',
    number: true,
    decimals: 2,
  },
  pretties: {
    id: 'Adereços',
    group: 'Banho',
    label: 'Adereço',
    prefix: 'R$ ',
    number: true,
    decimals: 2,
  },
  towels: {
    id: 'Toalhas',
    group: 'Banho',
    label: 'Toalha',
    prefix: 'R$ ',
    number: true,
    decimals: 2,
  },
}

export const DRE_RESPONSE_BLOCKS = {
  header: {
    type: 'neutral',
    format: (value) => formatName(moment(value).locale('pt-br').format('MMMM/YYYY'))
  },
  receivable: {
    name: 'Receita',
    column: 'receitas',
    type: 'inflow',
    format: (value) => `R$ ${formatMoney(value)}`,
  },
  costs: {
    name: 'Custos',
    column: 'custos',
    type: 'outflow',
    format: (value) => `R$ ${formatMoney(value)}`,
  },
  grossResult: {
    name: 'Resultado Bruto',
    column: 'resultadoBruto',
    type: 'settings',
    format: (value) => `R$ ${formatMoney(value)}`,
  },
  expenses: {
    name: 'Despesas',
    column: 'despesas',
    type: 'outflow',
    format: (value) => `R$ ${formatMoney(value)}`,
  },
  operationResult: {
    name: 'Resultado Operacional',
    column: 'resultadoOperacional',
    type: 'settings',
    format: (value) => `R$ ${formatMoney(value)}`,
  },
}

export const BATH_USED_PRODUCT = {
  neutralizing: {
    name: 'Shampoo Neutralizador',
    usage: {
      short: {
        name: 'Curto',
        quantities: ['100ml', '100ml', '300ml', '400ml', '600ml']
      },
      medium: {
        name: 'Médio',
        quantities: ['100ml', '200ml', '500ml', '600ml', '900ml']
      },
      long: {
        name: 'Longo',
        quantities: ['200ml', '300ml', '600ml', '800ml', '1.200ml']
      },
    }
  },
  neutral: {
    name: 'Shampoo Neutro',
    usage: {
      short: {
        name: 'Curto',
        quantities: ['100ml', '100ml', '300ml', '400ml', '600ml']
      },
      medium: {
        name: 'Médio',
        quantities: ['100ml', '200ml', '500ml', '600ml', '900ml']
      },
      long: {
        name: 'Longo',
        quantities: ['200ml', '300ml', '600ml', '800ml', '1.200ml']
      },
    },
  },
  conditioner: {
    name: 'Condicionador',
    usage: {
      short: {
        name: 'Curto',
        quantities: ['50ml', '50ml', '150ml', '200ml', '300ml']
      },
      medium: {
        name: 'Médio',
        quantities: ['50ml', '100ml', '250ml', '300ml', '450ml']
      },
      long: {
        name: 'Longo',
        quantities: ['100ml', '150ml', '300ml', '400ml', '600ml']
      },
    },
  },
}

export const TRANSACTION_METHODS = ['credit_card', 'pix']
export const TRANSACTION_TYPES = [
  'charge',
  'refund',
  'authorization',
  'capture',
  'verify',
  'register',
  'void',
  'renew_payment_profile',
  'pre_authorization',
  'update',
  'create_link'
]
export const TRANSACTION_STATUS = ['processing', 'success', 'rejected', 'failure', 'timeout', 'waiting', 'canceled', 'fraud_review']
export const TRANSACTION_PROCESSING_ERRORS = ['rejected', 'failure', 'timeout', 'fraud_review']
export const TRANSACTION_PROCESSING_WARNINGS = ['processing', 'waiting', 'fraud_review']

export const TRANSACTION_STATUS_TEXTS = {
  'processing': 'Processando',
  'success': 'Aprovado',
  'rejected': 'Rejeitado',
  'failure': 'Falha',
  'timeout': 'Tempo esgotado',
  'waiting': 'Aguardando pagamento',
  'canceled': 'Cancelado',
  'refund': 'Estornado',
  'fraud_review': 'Análise de fraude',
}

export const TRANSACTION_TYPE_TEXTS = {
  'void': 'Cancelamento',
  'charge': 'Cobrança',
  'refund': 'Estorno',
  'update': 'Atualização',
  'verify': 'Verificação',
  'capture': 'Captura',
  'register': 'Registro',
  'create_link': 'Link criado',
  'authorization': 'Autorização',
  'pre_authorization': 'Pré-autorização',
  'renew_payment_profile': 'Renovação de perfil de pagamento',
}

export const TRANSACTION_TYPE_COLORS = {
  'void': 'oklch(70.5% 0.015 286.067)',
  'charge': 'oklch(62.7% 0.194 149.214)',
  'refund': 'oklch(79.5% 0.184 86.047)',
  //
  'update': 'oklch(0.93 0.06 212.81)',
  'verify': 'oklch(0.93 0.06 212.81)',
  'capture': 'oklch(0.93 0.06 212.81)',
  'register': 'oklch(0.93 0.06 212.81)',
  'create_link': 'oklch(0.93 0.06 212.81)',
  'authorization': 'oklch(0.93 0.06 212.81)',
  'pre_authorization': 'oklch(0.93 0.06 212.81)',
  'renew_payment_profile': 'oklch(0.93 0.06 212.81)',
}

export const TRANSACTION_STATUS_COLORS = {
  'processing': 'oklch(70.4% 0.14 182.503)',
  'success': 'oklch(62.7% 0.194 149.214)',
  'rejected': 'oklch(58.6% 0.253 17.585)',
  'failure': 'oklch(66.7% 0.295 322.15)',
  'timeout': 'oklch(55.4% 0.046 257.417)',
  'waiting': 'oklch(79.5% 0.184 86.047)',
  'canceled': 'oklch(70.5% 0.015 286.067)',
  'refund': 'oklch(79.5% 0.184 86.047)',
  'fraud_review': 'oklch(71.5% 0.143 215.221)',
}
export const TRANSACTION_METHOD_TEXTS = {
  'credit_card': 'Cartão de crédito',
  'pix': 'Pix',
}
export const TRANSACTION_METHOD_COLORS = {
  'credit_card': 'oklch(74.6% 0.16 232.661)',
  'pix': 'oklch(76.8% 0.233 130.85)',
}

export const PAYMENT_ERROR_REASONS = {
  generic: "Contate a central do cartão para mais informações.",
  whitoutLimit: "Não autorizado, saldo ou limite insuficiente.",
  notAllowed: "Transação não permitida para o cartão - não tente novamente.",
  cardInvalid: "Nº cartão inválido, verifique os dados do cartão.",
  cardLost: "Cartão perdido, transação não permitida - não tente novamente.",
  cardStolen: "Cartão roubado, transação não permitida - não tente novamente.",
  cardExpired: "Cartão vencido, verifique os dados do cartão.",
  cardError: "Erro no cartão, verifique os dados do cartão.",
  fraud: "Fraude confirmada, transação não permitida para o cartão - não tente novamente.",
  fraudUspected: "Suspeita de fraude, contate a central do seu cartão.",
  invalidValue: "Valor da transação não permitido - não tente novamente.",
  invalidInstallment: "Parcelamento inválido - não tente novamente.",
  valueExcess: "Parcelamento inválido - não tente novamente.",
  errorAcquirer: "Erro no cartão – não tente novamente.",
  securityBreach: "Violação de segurança, verifique os dados do cartão.",
  requestRetry: "Refazer a transação.",
  exceededAttempts: "Excedidas tentativas de senha, contate a central do cartão.",
  systemFailure: "Falha de comunicação - tente mais tarde.",
}

export const BRAND_PAYMENT_ERROR_REASONS = {
  'mastercard': {
    '5': 'generic',
    '51': 'whitoutLimit',
    '57': 'notAllowed',
    '1': 'cardInvalid',
    '14': 'securityBreach',
    '63': 'fraudUspected',
    '30': 'errorAcquirer',
    '13': 'invalidValue',
    '12': 'invalidInstallment',
    '75': 'exceededAttempts',
    '41': 'cardLost',
    '43': 'cardStolen',
    '54': 'cardExpired',
    '58': 'notAllowed',
    '61': 'valueExcess',
    '88': 'cardInvalid',
    '91': 'systemFailure',
    '96': 'systemFailure',
    '4': 'fraud',
  },
  'hipercard': {
    '5': 'generic',
    '51': 'whitoutLimit',
    '57': 'notAllowed',
    '1': 'cardInvalid',
    '14': 'securityBreach',
    '63': 'fraudUspected',
    '30': 'errorAcquirer',
    '13': 'invalidValue',
    '12': 'invalidInstallment',
    '75': 'exceededAttempts',
    '41': 'cardLost',
    '43': 'cardStolen',
    '54': 'cardExpired',
    '58': 'notAllowed',
    '61': 'valueExcess',
    '88': 'cardInvalid',
    '91': 'systemFailure',
    '96': 'systemFailure',
    '4': 'fraud',
  },
  'visa': {
    '5': 'generic',
    '51': 'whitoutLimit',
    '57': 'notAllowed',
    '6': 'cardInvalid',
    '14': 'securityBreach',
    '59': 'fraudUspected',
    '19': 'errorAcquirer',
    '13': 'invalidValue',
    '75': 'exceededAttempts',
    '41': 'cardLost',
    '43': 'cardStolen',
    '54': 'cardExpired',
    '58': 'notAllowed',
    '61': 'valueExcess',
    'n4': 'valueExcess',
    '82': 'cardInvalid',
    '91': 'systemFailure',
    '96': 'systemFailure',
    '7': 'fraud',
  },
  'american-express': {
    '100': 'generic',
    '116': 'whitoutLimit',
    '200': 'notAllowed',
    '122': 'cardInvalid',
    '115': 'cardError',
    '110': 'ivalidValue',
    '106': 'exceededAttempts',
    '101': 'cardExpired',
    '911': 'systemFailure',
  },
  'elo': {
    '5': 'generic',
    '51': 'whitoutLimit',
    '57': 'notAllowed',
    '1': 'cardInvalid',
    '14': 'securityBreach',
    '63': 'fraudUspected',
    '30': 'errorAcquirer',
    '13': 'invalidValue',
    '12': 'invalidInstallment',
    '38': 'exceededAttempts',
    '41': 'cardLost',
    '43': 'cardStolen',
    '54': 'cardExpired',
    '57': 'notAllowed',
    '61': 'valueExcess',
    '82': 'cardInvalid',
    '91': 'systemFailure',
    '96': 'systemFailure',
  },
  'jcb': {},
  'diners-club': {},
}
